import React from "react";

const Gallery = (props) => {
  const [showMoreLimit, setShowMoreLimit] = React.useState(0);

  const showMoreImages = () => {
    props?.searchQuery({
      variables: {
        limit: 6,
        offset: showMoreLimit + 6,
      },
    });
    setShowMoreLimit(showMoreLimit + 6);
  };

  return (
    <div className="tab-content-cover">
      <div className="gallery-list-cover">
        <ul className="gallery-list">
          {props?.data?.map(({ image_url }) => {
            return (
              <li>
                <div className="gallery-box">
                  <img src={image_url} alt="gallery" />
                </div>
              </li>
            );
          })}
        </ul>
        {props?.count !== props?.data?.length && (
          <div className="show-more-btn">
            <button
              onClick={() => {
                if (!props?.loading) {
                  showMoreImages();
                }
              }}
              className="button"
            >
              {props?.loading ? "Loading..." : "Show More"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Gallery;
